
import CONSTANTES from '../constantes';
import { takeEvery, call,put } from 'redux-saga/effects'
import {actionAddCategoria, actionPutCatalogo } from '../acciones/accionesCatalogo';
import {message} from 'antd'
import moment from 'moment'
import { actionAddProductSuccess,actionEditConfigTarifasSuccess,actionEditProductSuccess,actionGetConfigTarifasSuccess } from '../acciones/accionesProductos';
const axios = require('axios');


// const getProductos = (page) => axios({
//   method: 'GET',
//   url: `${CONSTANTES.URL_API}/sellers/info_product/?ordering=-info_product__date_hight&page=${page}`,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })
//   .then(function (response) {
//     return response
//   })
//   .catch(error => {
//     return error.response
//   });

  const getProductos = (page) => axios({
    method: 'GET',
    url: `${CONSTANTES.URL_API}/sellers/info_tarifa_products/?ordering=-date_hight&page=${page}`,
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(function (response) {
      return response
    })
    .catch(error => {
      return error.response
    });

    const getProductosFilter = (page, filters) => axios({
      method: 'GET',
      url: `${CONSTANTES.URL_API}/sellers/info_tarifa_products/?ordering=-date_hight&page=${page}&search=${filters}`,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (response) {
        return response
      })
      .catch(error => {
        return error.response
      });

function* sagasGetProductos(values) {
  try {
    let response = null
    if(values.filters){
      response= yield call(getProductosFilter, values.page,values.filters);
    }
    else{
      response= yield call(getProductos, values.page);
    }
    if (response.data) {
      const addQR=[]
      console.log(response.data)
      // response.data.results.forEach(element => {
      //     addQR.push({...element, code_qr:`https://api.qrserver.com/v1/create-qr-code/?data=https://nfhpanel.web.app/productos/${element.id}&size=50x50`})
      // });
      yield put({ type: CONSTANTES.GET_PRODUCTS_SUCCESS, payload:response.data.results, total:response.data.count})
      //yield put({ type: CONSTANTES.GET_PRODUCTS_SUCCESS, payload:response.data})
    }

  } catch (error) {
      console.log(error)
  } 
}


const getProductDetail = (idProducto) => axios({
  method: 'GET',
  url: `${CONSTANTES.URL_API}/sellers/info_tarifa_products/${idProducto}/`,
  headers: {
    'Content-Type': 'application/json'
  }
})
  .then(response=>response)
  .catch(error=>error.response)


function* sagasGetProductDetail(values) {
  try {
    let detailProduct = yield call(getProductDetail, values.idProducto);
    if(detailProduct.status===200){
      yield put({ type: CONSTANTES.GET_PRODUCTS_DETAIL_SUCCESS, payload:detailProduct.data})
    }
    else{
      message.error("Error detail");
    }
  } catch (e) {
    console.log(e)
  }
}


const registroProducto = (producto) =>axios({
  method: 'POST',
  url: `${CONSTANTES.URL_API}/sellers/productos/`,
  data:JSON.stringify(producto),
  headers: {
      'Content-Type': 'application/json'
  }

})
.then(function (response) {
  return response
})
.catch(error=>  {
  return error.response
});


const registroInfoProducto = (producto) =>axios({
  method: 'POST',
  url: `${CONSTANTES.URL_API}/sellers/info_tarifa_products/`,
  data:producto,
  headers: {
      //'Content-Type': 'multipart/form-data',
      'Content-Type': 'application/json'
  }
})
.then(function (response) {
  return response
})
.catch(error=>  {
  return error.response
});

const filterProducts = (clave_producto) =>axios({
  method: 'GET',
  url: `${CONSTANTES.URL_API}/sellers/info_tarifa_products/?search=${clave_producto}`,
  headers: {
      //'Content-Type': 'multipart/form-data',
      'Content-Type': 'application/json'
  }
})
.then(function (response) {
  return response.data.results
})
.catch(error=>  {
  return error.response
});


function* sagasRegistroProducto(values) {
  try {
    let valuesProducto = values.values
    if (valuesProducto && valuesProducto.clave_producto) {
      let producto = yield call(filterProducts, valuesProducto.clave_producto);
      if (producto && producto.length > 0) {
        console.log(producto)
      }
      else {
        let infoProducto = yield call(registroInfoProducto, values.values);
        console.log(infoProducto)
        yield put(actionAddProductSuccess(infoProducto.data))
        message.success("Producto registrado");
      }
    }

  } catch (e) {
    console.log(e)
    message.error(e);
  }
}

// const editarProducto = (producto, idProdcut) =>axios({
//   method: 'PATCH',
//   url: `${CONSTANTES.URL_API}/sellers/productos/${idProdcut}/`,
//   data:JSON.stringify(producto),
//   headers: {
//       'Content-Type': 'application/json'
//   }

// })
// .then(response=>response)
// .catch(error=>error.response);


const editarInfoProducto = (producto, idInfoProduct) =>axios({
  method: 'PATCH',
  url: `${CONSTANTES.URL_API}/sellers/info_tarifa_products/${idInfoProduct}/`,
  data:producto,
  headers: {
      'Content-Type': 'multipart/form-data',
      //'Content-Type': 'application/json'
  }
})
.then(response=>response)
.catch(error=>error.response);


function* sagasEditarProducto(values) {
  try {
    console.log(values.values)
    const data = new FormData();
    Object.keys(values.values).map((key, index) => {
       if(values.values[key]){
        return data.append(key, values.values[key]);
       }  
    });
    data.append('date_modify', moment().format('YYYY-MM-DD'));
    let infoProducto = null
    infoProducto = yield call(editarInfoProducto, data, values.idInfoProduct);
    console.log('Info Producto', infoProducto)
    yield put(actionEditProductSuccess(values.values))
    message.success("Producto Editado");
  }

  catch (e) {
    console.log(e)
  }
}

const getConfigTarifas=()=> axios({
  method: 'GET',
  url: `${CONSTANTES.URL_API}/sellers/config_tarifas/`,
  headers: {
    'Content-Type': 'application/json'
  }
})
  .then(function (response) {
    return response
  })
  .catch(error => {
    return error.response
  });


  function* sagasGetConfigTarifas(values) {
    try {
      const response = yield call(getConfigTarifas);
      if (response.data && response.data.length>0) {
        yield put(actionGetConfigTarifasSuccess(response.data[0]))
      }
  
    } catch (error) {
        console.log(error)
    } 
  }


const editarConfigTarifas = (tarifas, idTarifa) => axios({
  method: 'PATCH',
  url: `${CONSTANTES.URL_API}/sellers/config_tarifas/${idTarifa}/`,
  data: tarifas,
  headers: {
    'Content-Type': 'application/json'
  }
})
  .then(response => response)
  .catch(error => error.response);


function* sagasEditGetConfigTarifas(values) {
  try {
    const response = yield call(editarConfigTarifas, values.values, values.idConfigTarifa);
    console.log(response)
    if (response.data && response.data.length > 0) {
      yield put(actionEditConfigTarifasSuccess(response.data[0]))
    }
  } catch (error) {
    console.log(error)
  }
}


export default function* SagasProductos() {
    yield takeEvery(CONSTANTES.GET_PRODUCTS, sagasGetProductos)
    yield takeEvery(CONSTANTES.GET_PRODUCT_DETAIL, sagasGetProductDetail)
    yield takeEvery(CONSTANTES.ADD_PRODUCT, sagasRegistroProducto) 
    yield takeEvery(CONSTANTES.UPDATE_PRODUCT, sagasEditarProducto)
    yield takeEvery(CONSTANTES.GET_CONFIG_TARIFAS, sagasGetConfigTarifas)
    yield takeEvery(CONSTANTES.EDIT_TARIFAS_REQUEST, sagasEditGetConfigTarifas)
}